// src/services/api.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// -------------------------------
// INTERCEPTOR PARA ENVIAR TOKEN
// -------------------------------
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// -------------------------------
// INTERCEPTOR DE RESPOSTA (opcional)
// Se o backend retornar 401, podemos deslogar automaticamente
// -------------------------------
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Token expirado ou inválido");
    }
    return Promise.reject(error);
  }
);

export default api;
